/** Join class names (shadcn-style); falsy entries omitted. */
export function cn(...inputs) {
  return inputs.filter(Boolean).join(' ');
}
